module.exports = __webpack_public_path__ + "img/body-icon.d4f588ce.svg";